/*
 * Copyright (c) Vaisala Oyj. All rights reserved.
 */

import { ClassConstructor } from 'class-transformer';
import { getDefaultParameters } from '../calculator/chemical-curve/configParser';
import UnitController from '../units/UnitController';

type PersistentProperty = keyof PersistenceDefaults;

class PersistenceDefaults {
  theme = '';
  unitIndex = 0;
  unitManualPreset = UnitController.defaultManualPreset;
  calculatorResult = [getDefaultParameters('closedSystem'), getDefaultParameters('openSystem'), getDefaultParameters('freeEvaporation')];
  activeMethodIndex = -1;
  allChemicalCurves = [];
  polarispr53 = [];
  recent = [];
  recent_pr53 = [];
}

class PersistenceController {
  private static _instance: PersistenceController;
  private _storage = window.localStorage;
  private _session = window.sessionStorage;
  private _defaults?: PersistenceDefaults;

  public static get instance() {
    return this._instance || (this._instance = new this());
  }

  // retrieves a property from browser cache
  public retrieve(prop: PersistentProperty, asClass?: ClassConstructor<unknown>) {
    const stored = this._storage.getItem(prop);
    //console.log('PersistenceController.retrieve(' + prop + '): ', stored);
    if (stored) {
      return JSON.parse(stored);
    } else {
      if (!this._defaults) {
        this._defaults = new PersistenceDefaults();
      }
      return this._defaults[prop];
    }
  }

  public retrieveSession(prop: PersistentProperty, asClass?: ClassConstructor<unknown>) {
    const stored = this._session.getItem(prop);
    if (stored) {
      return JSON.parse(stored);
    } else {
      if (!this._defaults) {
        this._defaults = new PersistenceDefaults();
      }
      return this._defaults[prop];
    }
  }

  // stores a property to browser cache
  public store(prop: PersistentProperty, value: any) {
    // console.log('PersistenceController.store(' + prop + '): ', value);
    this._storage.setItem(prop, JSON.stringify(value));
  }

  // stores a property to browser cache
  public storeSession(prop: PersistentProperty, value: any) {
    // console.log('PersistenceController.store(' + prop + '): ', value);
    this._session.setItem(prop, JSON.stringify(value));
  }

  // debugging purposes only: clears the browser cache
  public clear() {
    console.warn('PersistenceController.clear()');
    this._storage.clear();
  }
}

export default PersistenceController.instance;
